<template>
  <div class="mx-3 mb-15 collection-page fade-in">
    <div class="mb-3 title text-h6 font-weight-black">{{ collection.name }}</div>
    <div class="mb-1">
      <img :src="thumbnailURL" width="100%"/>
    </div>
    <div class="mb-3 d-flex justify-spece-between">
      <Flower :flower="primaryFlower" />
      <Flower :flower="secondaryFlower" />
    </div>
    <div>
      <v-btn height="15" x-large block color="#191D38" class="white--text" :to="url" :disabled="!collection.is_open">
        {{ collection.is_open ? 'コレクションを見る' : 'Coming Soon' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import Flower from "@/components/shop/collections/Flower.vue";

export default {
  components: { Flower },
  props: {
    collection: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      url: `/shop/collections/${this.collection.id}`
    };
  },
  computed: {
    primaryFlower() {
      return this.collection.collection_flowers[0]?.flower;
    },
    secondaryFlower() {
      return this.collection.collection_flowers[1]?.flower;
    },
    thumbnailURL() {
      return this.collection.images[0].image_url;
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.collection-page {
  font-family: 'Inter';
}

.title {
  color: #191D38;
}
</style>
